import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  DatePicker,
  Spin,
  Typography,
  Table,
  Tag,
  Divider,
  Tabs,
} from "antd";
import moment from "moment";
import Page from "_components/Page";
import {
  companyService,
  materialRequestService,
  measurementTypeService,
} from "_services";
import { FilePdfOutlined } from "@ant-design/icons";
import { Auth, Utils } from "_helpers";

function PrymSummary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [materialRequest, setMaterialRequest] = useState({});
  const [customers, setCustomers] = useState([]);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [materialRequestLines, setMaterialRequestLines] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const { Option } = Select;
  const { Text } = Typography;
  const { TextArea } = Input;
  const loggedInCustomerCode = Auth.getProfile().comp_code;

  useEffect(() => {
    setLoading(true);
    materialRequestService
      .getById(id)
      .then((x) => {
        //console.log("MR:", x.content);
        let materialRequest = x.content;

        //materialRequest.customer = materialRequest.customer.id;
        //materialRequest.deliveryLocation = materialRequest.deliveryLocation.id;
        materialRequest.requestDate = moment(materialRequest.requestDate);
        materialRequest.requestLines.forEach((item, i) => {
          item.key = i;
          item.requestedQuantity = item.requestedItems.length;
          if (item.requestedItems && item.requestedItems.length > 0) {
            item.netWeight = item.requestedItems
              .map((item) => item.netWeight)
              .reduce((prev, next) => prev + next);
            item.grossWeight = item.requestedItems
              .map((item) => item.grossWeight)
              .reduce((prev, next) => prev + next);

            item.requestedItems.forEach((stock) => {
              stock.stockType = item.stockType;
              stock.lotNumber = item.lotNumber;
            });
          }
        });

        setMaterialRequest(materialRequest);
        setMaterialRequestLines(materialRequest.requestLines);
        getCustomerAddresses(materialRequest.customer.id);
        onFill(materialRequest);
        setLoading(false);
        //console.log("MR: ", materialRequest);
        //console.log("FormVal: ", form.getFieldValue("purchaseOrderLines"));
      })
      .catch((errorInfo) => {
        setLoading(false);
        message.error(`${errorInfo}`);
      });

    companyService.getSuggestion("?companyType=CUSTOMER").then((x) => {
      setCustomers(x.content);
    });
    measurementTypeService.getSuggestion().then((data) => {
      setMeasurementTypes(data.content);
    });
  }, []);

  const getCustomerAddresses = (companyId) => {
    companyService.getById(companyId).then((data) => {
      const officeAddress = data.content.addresses.filter(
        (item) => item.addressType === "OFFICE"
      );
      setCustomerAddresses(officeAddress);
    });
  };

  const handlePrintPdf = () => {
    setLoadingPdf(true);
    materialRequestService.printPdf(id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Stock-issue-request-${materialRequest.requestNumber}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoadingPdf(false);
    });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCreateDelivery = () => {
    history.push(`/stock-issue/add?mrn=${id}`);
  };

  const onCancel = () => {
    history.push("/material-requests");
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button
        key="pdf"
        icon={<FilePdfOutlined />}
        onClick={handlePrintPdf}
        loading={loadingPdf}
      ></Button>
    );
    if (
      ["OPEN", "IN_PROGRESS", "ACCEPTED"].includes(
        materialRequest && materialRequest.orderStage
      ) &&
      Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])
    ) {
      buttons.push(
        <Button
          key="delivery"
          htmlType="button"
          type="primary"
          onClick={onCreateDelivery}
        >
          Create Delivery
        </Button>
      );
    }
    buttons.push(
      <Button key="cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Material Type",
      key: "stockTypeCode",
      width: "20%",
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      width: "30%",
      render: (text, record) => {
        return record.stockType.name;
      },
    });
    columns.push({
      title: "Lot Number",
      dataIndex: "lotNumber",
      key: "lotNumber",
      width: "20%",
      render: (text, record, index) => {
        return record.lotNumber && record.lotNumber.number;
      },
    });
    columns.push({
      title: "Rolls/Box",
      dataIndex: "totalItems",
      key: "totalItems",
      align: "right",
    });
    columns.push({
      title: "Quantity",
      key: "quantity",
      align: "right",
      render: (text, record) => {
        return Number(record.quantity).toFixed(2);
      },
    });
    columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      width: "3%",
      render: (text, record) => {
        return record.measurementType && record.measurementType.name;
      },
    });

    return columns;
  };

  const getStockItemColumns = () => {
    let columns = [];
    columns.push({
      title: "Material Type",
      dataIndex: "stockType",
      key: "stockType",
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    /* columns.push({
      title: "Description",
      key: "stockTypeName",
      width: "15%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip
            placeholder="topLeft"
            title={record.stockType.name}
          >
            {record.stockType.name}
          </Tooltip>
        );
      },
    }); */
    columns.push({
      title: `${["SILUETA"].includes(loggedInCustomerCode)
          ? "Vendor Batch"
          : "Lot/Batch Number"
        }`,
      dataIndex: "lotNumber",
      key: "lotNumber",
      render: (text, record) => {
        return record.lotNumber && record.lotNumber.number;
      },
    });
    if (
      materialRequest.customer &&
      ["PRYM", "SILUETA"].includes(materialRequest.customer.code)
    ) {
      columns.push({
        title: "Roll/Box No:",
        dataIndex: "runningNo",
        key: "runningNo",
        /* align: "right", */
      });
    }
    /* columns.push({
      title: "Location",
      key: "storeLocation",
      render: (text, record) => {
        return record.stockBin.storeLocation.address;
      },
    }); */
    columns.push({
      title: "Stock Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      render: (text, record) => {
        return record.stockBin.code;
      },
    });
    if (
      materialRequest.customer &&
      ["SILUETA"].includes(materialRequest.customer.code)
    ) {
      columns.push({
        title: "Pallet No",
        dataIndex: "palletNo",
        key: "palletNo",
      });
    }
    if (
      materialRequest.customer &&
      ["STR-RM"].includes(materialRequest.customer.code)
    ) {
      columns.push({
        title: "Units",
        dataIndex: "quantity",
        key: "quantity",
        align: "right",
      });
    }
    if (
      materialRequest.customer &&
      ["PRYM"].includes(materialRequest.customer.code)
    ) {
      columns.push({
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        align: "right",
      });
    }
    columns.push({
      title: "Net Measure",
      dataIndex: "netWeight",
      key: "netWeight",
      align: "right",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    });
    columns.push({
      title: "Gross Measure",
      dataIndex: "grossWeight",
      key: "grossWeight",
      align: "right",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    });
    if (
      materialRequest.customer &&
      ["PRYM"].includes(materialRequest.customer.code)
    ) {
      columns.push({
        title: "Gross (Sq.m)",
        dataIndex: "grossValueSqm",
        key: "grossValueSqm",
        align: "right",
        render: (text, record) => {
          return text && Number(text).toFixed(2);
        },
      });
    }
    columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      width: "3%",
      render: (text, record) => {
        return record.measurementType && record.measurementType.name;
      },
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });

    return columns;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-requests">Material Request Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                {materialRequest.requestNumber} ::{" "}
                <Tag
                  color={`${materialRequest.orderStage === "OPEN"
                      ? "#2db7f5"
                      : ["IN_PROGRESS", "ACCEPTED"].includes(
                        materialRequest.orderStage
                      )
                        ? "#108ee9"
                        : "#87d068"
                    }`}
                >
                  {materialRequest.orderStage}
                </Tag>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <Spin tip="Loading..." spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["customer", "id"]}
                    label="Customer"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Please select"
                      onChange={getCustomerAddresses}
                    >
                      {customers.length > 0 &&
                        customers.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="contactPersonName" label="Contact Person">
                    <Input placeholder="Contact number" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="requestDate"
                    label="Request Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder="Request date"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="requestNumber"
                    label="Request No"
                    rules={[{ required: true }]}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["deliveryLocation", "id"]}
                    label="Deliver To"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Please select">
                      {customerAddresses.length > 0 &&
                        customerAddresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="contactNumber" label="Contact No:">
                    <Input placeholder="Contact number" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="remark" label="Remark">
                    <TextArea />
                  </Form.Item>
                </Col>
              </Row>
              <Table
                bordered
                pagination={false}
                columns={getLineColumns()}
                dataSource={materialRequestLines}
                rowClassName={(record) => (record.lineStage === "COMPLETE" ? "ant-tag-green" : "")}
                size="small"
                summary={(pageData) => {
                  let rollSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let boxSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let spoolSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let boxPcsSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let boxNosSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let boxConeSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let boxStripSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let boxRibnSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let bundlesSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  let defaultSummary = {
                    totalItems: 0,
                    totalQty: 0,
                    uom: "",
                    measurementType: null,
                  };
                  const groupByPackingType = Utils.groupBy(
                    pageData,
                    (line) =>
                      line.stockType &&
                      line.stockType.packingType &&
                      line.stockType.packingType.name
                  );

                  groupByPackingType.forEach((value, key) => {
                    if (key === "ROLL") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          rollSummary.totalItems += totalItems;
                          rollSummary.totalQty += quantity;
                          rollSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BOX") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          boxSummary.totalItems += totalItems;
                          boxSummary.totalQty += quantity;
                          boxSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "SPOOL") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          spoolSummary.totalItems += totalItems;
                          spoolSummary.totalQty += quantity;
                          spoolSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BOX_PCS") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          boxPcsSummary.totalItems += totalItems;
                          boxPcsSummary.totalQty += quantity;
                          boxPcsSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BOX_NOS") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          boxNosSummary.totalItems += totalItems;
                          boxNosSummary.totalQty += quantity;
                          boxNosSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BOX_CONE") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          boxConeSummary.totalItems += totalItems;
                          boxConeSummary.totalQty += quantity;
                          boxConeSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BOX_STRP") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          boxStripSummary.totalItems += totalItems;
                          boxStripSummary.totalQty += quantity;
                          boxStripSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BOX_RIBN") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          boxRibnSummary.totalItems += totalItems;
                          boxRibnSummary.totalQty += quantity;
                          boxRibnSummary.measurementType = measurementType;
                        }
                      );
                    } else if (key === "BUNDLES") {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          bundlesSummary.totalItems += totalItems;
                          bundlesSummary.totalQty += quantity;
                          bundlesSummary.measurementType = measurementType;
                        }
                      );
                    } else {
                      value.forEach(
                        ({ totalItems, quantity, measurementType }) => {
                          defaultSummary.totalItems += totalItems;
                          defaultSummary.totalQty += quantity;
                          defaultSummary.measurementType = measurementType;
                        }
                      );
                    }
                  });
                  /* measurementTypes.forEach((item) => {
                    if (item.id === rollSummary.measurementType) {
                      rollSummary.uom = item.name;
                    } else if (item.id === boxSummary.measurementType) {
                      boxSummary.uom = item.name;
                    } else if (item.id === spoolSummary.measurementType) {
                      spoolSummary.uom = item.name;
                    } else if (item.id === boxPcsSummary.measurementType) {
                      boxPcsSummary.uom = item.name;
                    } else if (item.id === boxNosSummary.measurementType) {
                      boxNosSummary.uom = item.name;
                    } else if (item.id === boxConeSummary.measurementType) {
                      boxConeSummary.uom = item.name;
                    } else if (item.id === bundlesSummary.measurementType) {
                      bundlesSummary.uom = item.name;
                    } else {
                      defaultSummary.uom = item.name;
                    }
                  }); */

                  return (
                    <>
                      {rollSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - ROLL</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(rollSummary.totalItems) &&
                                rollSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(rollSummary.totalQty) &&
                                rollSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>
                              {rollSummary.measurementType.name}
                            </Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {boxSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BOX</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxSummary.totalItems) &&
                                boxSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxSummary.totalQty) &&
                                boxSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{boxSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {spoolSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - SPOOL</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(spoolSummary.totalItems) &&
                                spoolSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(spoolSummary.totalQty) &&
                                spoolSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{spoolSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {boxPcsSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BOX(PCS)</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxPcsSummary.totalItems) &&
                                boxPcsSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxPcsSummary.totalQty) &&
                                boxPcsSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{boxPcsSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {boxNosSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BOX(NOS)</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxNosSummary.totalItems) &&
                                boxNosSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxNosSummary.totalQty) &&
                                boxNosSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{boxNosSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {boxConeSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BOX(CONE)</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxConeSummary.totalItems) &&
                                boxConeSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxConeSummary.totalQty) &&
                                boxConeSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{boxConeSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {boxStripSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BOX(STRP)</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxStripSummary.totalItems) &&
                                boxStripSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxStripSummary.totalQty) &&
                                boxStripSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{boxStripSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {boxRibnSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BOX(RIBN)</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxRibnSummary.totalItems) &&
                                boxRibnSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(boxRibnSummary.totalQty) &&
                                boxRibnSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{boxRibnSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {bundlesSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total - BUNDLES</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(bundlesSummary.totalItems) &&
                                bundlesSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(bundlesSummary.totalQty) &&
                                bundlesSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{bundlesSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                      {defaultSummary.totalItems > 0 && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={3}>
                            <Text strong>Total</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(defaultSummary.totalItems) &&
                                defaultSummary.totalItems}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text strong>
                              {!isNaN(defaultSummary.totalQty) &&
                                defaultSummary.totalQty}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <Text strong>{defaultSummary.measurementType.name}</Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                    </>
                  );
                }}
              />
              {materialRequestLines.flatMap((item) => item.requestedItems) &&
                materialRequestLines.flatMap((item) => item.requestedItems)
                  .length > 0 && (
                  <>
                    <Divider orientation="left">
                      Requested Stock Items{" "}
                      {
                        materialRequestLines.map((item) => item.requestedItems)
                          .length
                      }
                    </Divider>
                    <Tabs defaultActiveKey={materialRequestLines[0].key}>
                      {materialRequestLines.map((line, index) => (
                        <Tabs.TabPane
                          tab={`${line.stockType.code} / ${line.lotNumber.number} (${line.requestedItems.length})`}
                          key={index}
                        >
                          <Table
                            bordered
                            size="small"
                            rowKey="id"
                            columns={getStockItemColumns()}
                            dataSource={line.requestedItems}
                            pagination={false}
                            summary={(pageData) => {
                              let totalQuantity = 0;
                              let totalNetWeight = 0;
                              let totalGrossWeight = 0;

                              pageData.forEach(
                                ({ quantity, netWeight, grossWeight }) => {
                                  //totalQuantity += quantity ? quantity : 1;
                                  totalQuantity += quantity;
                                  totalNetWeight += netWeight;
                                  totalGrossWeight += grossWeight;
                                }
                              );

                              return (
                                <>
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell
                                      colSpan={getStockItemColumns().length - 5}
                                    >
                                      <Text strong>Total</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell align="right">
                                      <Text strong style={{ paddingLeft: 12 }}>
                                        {/* totalQuantity */}
                                      </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell align="right">
                                      <Text strong>
                                        {Number(totalNetWeight).toFixed(2)}
                                      </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell align="right">
                                      <Text strong>
                                        {Number(totalGrossWeight).toFixed(2)}
                                      </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={2} />
                                  </Table.Summary.Row>
                                </>
                              );
                            }}
                          />
                        </Tabs.TabPane>
                      ))}
                    </Tabs>
                  </>
                )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default PrymSummary;
